import * as _ from "lodash";

var PrimaryPlanTxnAccessSvc = function ($http, $q, $window) {
    var cacheUrl = __baseApiUrl__ + "/participant-web-services/rest/primaryPlan/hasTxnAccess/";
    var cache = {};
    var pending = {};

    var hasAccessCodes = function (txnCodes) {
        return _.every(txnCodes.split(","), function (code) {
            return _.has(cache, _.trim(code));
        });
    };

    this.query = function (params) {
        if (pending[params.txnCode]) {
            return pending[params.txnCode];
        }
        var url = cacheUrl + params.txnCode;
        var deferred = $q.defer();
        pending[params.txnCode] = deferred.promise;
        if (hasAccessCodes(params.txnCode)) {
            deferred.resolve(cache);
            delete pending[params.txnCode];
        } else {
            $http({
                url: url,
                method: "GET",
                isArray: false
            })
                .then(function (resp) {
                    _.extend(
                        cache,
                        _.mapValues(resp.data, function (value) {
                            return value === "true" || value === true;
                        })
                    );
                    deferred.resolve(cache);
                    delete pending[params.txnCode];
                })
                .catch(() => {
                    delete pending[params.txnCode];
                });
        }
        return deferred.promise;
    };

    return {
        query: this.query
    };
};

PrimaryPlanTxnAccessSvc.$inject = ["$http", "$q", "$window"];
export default PrimaryPlanTxnAccessSvc;
